import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';
import CustomerActions from '../../actions/CustomerActions';
import ModalActions from '../../actions/ModalActions';
import UserStore from '../../stores/UserStore';

import BaseModal from './BaseModal';
import BrandSplitSuccess from './BrandSplitSuccess';

class BrandSplitModal extends React.PureComponent {

    static propTypes = {
        show: PropTypes.bool
    };

    static defaultProps = {
        show: true
    };

    state = {
        brandChosen: 'thameslink'
    }

    _handleContinue = () => {
        CustomerActions.setPreferredBrand(UserStore.getCurrent(), this.state.brandChosen);
        ModalActions.open(BrandSplitSuccess, { brand: this.state.brandChosen });
    }

    _renderHeader = () => {
        return (
            <h4 className="modal-title text-left">
                { t('brand.split.header') }
            </h4>
        );
    }

    _handleSelection = (brandChosen) => () => this.setState({ brandChosen });

    _renderOption (brandName) {
        const logo = `/images/logos/${brandName}-logo-mobile.png`;
        const selected = this.state.brandChosen === brandName;

        let iconClassNames = classnames('brand-selector__radio otrl', {
            'otrl-select': !selected,
            'otrl-selected': selected
        });
        const classes = classnames(`brand-selector ${brandName} box box--padded box--rounded box--clickable`);
        return (
            <div id="brand-container" className={ classes } onClick={ this._handleSelection(brandName) }>
                <img src={ logo } alt={ brandName } />
                <div className="pull-right text-right">
                    <span className={ iconClassNames }>
                    <input type="radio"
                        name="brandChosen"
                        checked={ selected }
                        onChange={ this._handleSelection(brandName) } />
                    </span>
                </div>
            </div>
        );
    }

    render () {
        const modalProps = {
            show: this.props.show,
            className: 'modal--xs',
            onContinue: this._handleContinue,
            continueText: 'button.text.select',
            header: this._renderHeader(),
            hideClose: true,
            disableEscape: true
        };
        return (
            <BaseModal { ...modalProps }>
                <div className="vertical-align-parent full-height">
                    <form name="brand">

                        <div className="padding-top--sm">
                            <p className="text-secondary text-weight--normal">{ t('brand.split.text') }</p>
                                { this._renderOption('thameslink') }
                                { this._renderOption('greatnorthern') }
                        </div>

                    </form>
                </div>
            </BaseModal>
        );
    }
}

export default BrandSplitModal;



// WEBPACK FOOTER //
// ./src/components/general/BrandSplitModal.js